import React,{useRef} from 'react';
import { Growl } from 'primereact/growl';
import { TablaCesantiaVejez } from './TablaCesantiaVejez';

export const CensantiaVejezPatronal2023 = () => {    

    let growl = useRef(null);

    return (<div>
        <Growl ref={growl} />
        <div className="p-grid">
            <div className="p-col-12">
                <div className="card">
                    <h1>CESANTÍA Y VEJEZ PATRONAL</h1>
                </div>
            </div>
        </div>
        <TablaCesantiaVejez growl={growl}/>
    </div>);
}